/** @jsx jsx */

import { MouseEvent } from 'react';

import { jsx } from '@emotion/core';
import {
  Alert,
  AlertDescription,
  Button,
  ButtonGroup,
} from '@zapier/design-system';

import VersioningHelpButton from './VersioningHelpButton';
import { getNonEditableUiReason } from './utils';

type Props = {
  appName: string;
  onCloneClick: (event: MouseEvent) => void;
  openVersionHelp: (event: MouseEvent) => void;
  userCount: number;
};

/**
 * When an integration is non editable (public or has more users than USER_LIMIT_COUNT)
 * we render an information message on the top of the pages with forms
 * @param props Props
 */
const CtaNonEditableVersion = ({
  appName,
  onCloneClick,
  openVersionHelp,
  userCount,
}: Props) => {
  const reason = getNonEditableUiReason(userCount);
  const description = `Since this version of your integration ${reason}, you have to create a new editable version by cloning it.`;

  return (
    <Alert status="info" title={`You can’t edit this version of ${appName}.`}>
      <AlertDescription>{description}</AlertDescription>
      <ButtonGroup columnSize="minmax(0, auto)" justify="start">
        <VersioningHelpButton onClick={openVersionHelp} />
        <Button color="primary" onClick={onCloneClick}>
          Clone Version
        </Button>
      </ButtonGroup>
    </Alert>
  );
};

export default CtaNonEditableVersion;
